import React from 'react';
import PropTypes from 'prop-types';

import { Image, Link } from 'components';

const ImageCTA = ({
  button,
  image
}) => {

  return (
    <div className='image-cta'>
      {button && <Link to={button.path} external={button.external} newTab={button.newTab} className='button center'>{button.label}</Link>}
      <Image class="image-cta__image" url={image.url} alt={image.alt} />
    </div>
  );
};

ImageCTA.propTypes = {
  button: PropTypes.shape({
    label: PropTypes.string.isRequired,
    path: PropTypes.string.isRequired,
    external: PropTypes.bool.isRequired,
    newTab: PropTypes.bool.isRequired,
  }),
  image: PropTypes.shape({
    url: PropTypes.string.isRequired,
    alt: PropTypes.string.isRequired,
    noBlur: PropTypes.bool,
  }).isRequired,
};

export default ImageCTA;
